// extracted by css-extract-rspack-plugin
export default {"cls1":"ReferenceEvaluationPage-cls1_Z3A","cls2":"ReferenceEvaluationPage-cls2_YE9 ReferenceEvaluationPage-cls1_Z3A","pulse":"ReferenceEvaluationPage-pulse_u7s"};